import PageHeader from "@/components/PageHeader";
import RecordsSection from "@/components/RecordsSection";
import ParoleView from "@/components/ParoleView";
import HaftantrittView from "@/components/HaftantrittView";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { infoColumns, infoFields, inhaftColumns, inhaftFields, einsatzColumns, einsatzFields, chainColumns, chainFields, fehlerColumns, fehlerFields, appellColumns, appellFields } from "@/lib/entities";
import { Archive } from "lucide-react";

const TABS = [
  { value: "informationen", label: "Informationen", endpoint: "/informationen", columns: infoColumns, fields: infoFields, prefix: "arch-info" },
  { value: "appellthemen", label: "Appellthemen", endpoint: "/appellthemen", columns: appellColumns, fields: appellFields, prefix: "arch-appell" },
  { value: "fehlerliste", label: "Fehlerliste", endpoint: "/fehlerliste", columns: fehlerColumns, fields: fehlerFields, prefix: "arch-fehler" },
  { value: "inhaftierungen", label: "Inhaftierung", endpoint: "/inhaftierungen", columns: inhaftColumns, fields: inhaftFields, prefix: "arch-inhaft" },
  { value: "einsaetze", label: "Einsätze", endpoint: "/einsaetze", columns: einsatzColumns, fields: einsatzFields, prefix: "arch-einsatz" },
  { value: "chaingangs", label: "Chain-Gangs", endpoint: "/chaingangs", columns: chainColumns, fields: chainFields, prefix: "arch-chain" },
];

const HAFTANTRITT_TABS = [
  { value: "haftantritt_erschienen", label: "Haftantritt · Erschienen", mode: "erschienen", prefix: "arch-haft-ok" },
  { value: "haftantritt_nicht_erschienen", label: "Haftantritt · Nicht Erschienen", mode: "nicht_erschienen", prefix: "arch-haft-fail" },
];

const PAROLE_TABS = [
  { value: "parole_erfolgreich", label: "Parole · Erfolgreich", mode: "erfolgreich", prefix: "arch-parole-ok", bereich: "parole" },
  { value: "parole_fehlgeschlagen", label: "Parole · Fehlgeschlagen", mode: "fehlgeschlagen", prefix: "arch-parole-fail", bereich: "parole" },
  { value: "resoz_erfolgreich", label: "Resozialisierung · Erfolgreich", mode: "erfolgreich", prefix: "arch-resoz-ok", bereich: "resozialisierung" },
  { value: "resoz_fehlgeschlagen", label: "Resozialisierung · Fehlgeschlagen", mode: "fehlgeschlagen", prefix: "arch-resoz-fail", bereich: "resozialisierung" },
];

export default function Archiv() {
  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Archiv"
        title="Archiv"
        description="Archivierte Einträge einsehen, wiederherstellen oder löschen."
        icon={Archive}
      />
      <div className="p-8">
        <Tabs defaultValue="informationen">
          <TabsList className="bg-[#0C0E12] border border-zinc-800 rounded-sm p-1 h-auto gap-1 flex-wrap justify-start">
            {[...TABS, ...HAFTANTRITT_TABS, ...PAROLE_TABS].map((t) => (
              <TabsTrigger
                key={t.value}
                value={t.value}
                data-testid={`archiv-tab-${t.value}`}
                className="rounded-sm data-[state=active]:bg-primary data-[state=active]:text-white text-zinc-400 text-xs uppercase tracking-wide font-medium px-4 py-2"
              >
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {TABS.map((t) => (
            <TabsContent key={t.value} value={t.value} className="mt-6">
              <RecordsSection
                endpoint={t.endpoint}
                columns={t.columns}
                fields={t.fields}
                makeDefault={() => ({})}
                mode="archive"
                emptyLabel="Keine archivierten Einträge"
                testidPrefix={t.prefix}
              />
            </TabsContent>
          ))}
          {HAFTANTRITT_TABS.map((t) => (
            <TabsContent key={t.value} value={t.value} className="mt-6">
              <HaftantrittView mode={t.mode} testidPrefix={t.prefix} />
            </TabsContent>
          ))}
          {PAROLE_TABS.map((t) => (
            <TabsContent key={t.value} value={t.value} className="mt-6">
              <ParoleView mode={t.mode} testidPrefix={t.prefix} bereich={t.bereich} />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
